import { useContext } from 'react';
import PreQualificationPages from 'src/context/preQualPages/preQualificationPagesContext';

const usePreQualificationPages = () => {
  return useContext(PreQualificationPages);
};

export default usePreQualificationPages;
